import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider } from "./AuthContext";
import RequireAuth from "./RequireAuth";
import AdminLogin from "./AdminLogin";
import TemplateEditor from "./TemplateEditor";
import CategoryImageManager from "./CategoryImageManager";

import AdminLayout from "./AdminLayout";
import AdminDashboard from "./sections/Dashboard";
import AdminUsers from "./sections/Users";
import AdminTicketsQueue from "./sections/TicketsQueue";
import AdminTicketDetail from "./sections/TicketDetail";
import AdminServiceRequests from "./sections/ServiceRequests";
import AdminAccess from "./sections/AdminAccess";
import StaffOnboarding from "./sections/StaffOnboarding";
import { PaymentsStub } from "./sections/ComingSoon";

import "./nocturne.css";
import "./admin.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/onboarding" element={<StaffOnboarding />} />

          <Route
            path="/"
            element={
              <RequireAuth>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="payments" element={<PaymentsStub />} />
            <Route path="requests" element={<AdminServiceRequests />} />
            <Route path="requests/:id" element={<AdminServiceRequests />} />
            <Route path="tickets" element={<AdminTicketsQueue />} />
            <Route path="tickets/:id" element={<AdminTicketDetail />} />
            <Route path="taxonomy" element={<TemplateEditor />} />
            <Route path="media" element={<CategoryImageManager />} />
            <Route path="access" element={<AdminAccess />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
